import { render, staticRenderFns } from "./BankNumberConfirmation.vue?vue&type=template&id=24d01821&"
import script from "./BankNumberConfirmation.vue?vue&type=script&lang=js&"
export * from "./BankNumberConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports